export default __webpack_public_path__ + "assets/images/340d9883ec13549d60466c7722a0fe0b.png";